import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'
import routes from '@/Router/routes.constants'

const useCreateDefaultDeliveryMethods = ({ storeId, updateContext, setToastInfo }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { fetchData, loading } = useFetch(configurationServices.createDefaultDeliveryMethods, {
    doInitialRequest: false,
  })

  const createDefaultDeliveryMethods = async locationId => {
    try {
      await fetchData({ storeId, locationId })

      updateContext(context => ({ ...context, has_delivery_methods: true }))
      navigate(routes.configurationPage.logistics.deliveryMethods)
    } catch {
      setToastInfo({
        show: true,
        message: t('Ha ocurrido un error al crear tus Return Methods. Inténtalo de nuevo.'),
        type: 'error',
      })
    }
  }

  return {
    createDefaultDeliveryMethods,
    creatingDefaultDeliveryMethods: loading,
  }
}

export default useCreateDefaultDeliveryMethods
